import { errorlog } from '@/libs/error-logs';
import { toast_error } from '@/libs/toast-wrappers';
import { toError } from '@/utils/errors';

import { GET, PATCH } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

export type Signup = {
  user_id: string;
  user_email: string;
  name: string;
  requestedRole: string;
  clinic: string; // Free-text clinic name from signup form
  phone: string;
  country: string;
  city: string;
  provinceState: string;
  postal?: string;
  address?: string;
  created_at: string; // ISO timestamp
  approved_at?: string | null;
};

export async function getUserSignups(onlyNew = false) {
  try {
    const response = await GET<StandardResponse<Signup[]>>(ENDPOINTS.SIGNUPS, {
      query: onlyNew ? { only_new: 'true' } : {},
    });
    console.log('response', response);
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/signups/getUserSignups', 'Error fetching signups');
    toast_error('Error fetching user signups');
    return Promise.reject(toError(error));
  }
}

export async function getSignupByEmail(userEmail: string) {
  try {
    const response = await GET<StandardResponse<Signup>>(ENDPOINTS.SIGNUP_BY_EMAIL, {
      parameters: { userEmail },
    });
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/signups/getSignupByEmail', 'Error fetching signup by email');
    toast_error('Error fetching signup details');
    return Promise.reject(toError(error));
  }
}

export type ApproveSignupPayload = {
  user_email: string;
  name: string;
  phone: string;
  country: string;
  city: string;
  provinceState: string;
  requestedRole: string;
  clinic_id: string;
  postal?: string;
  address?: string;
};

export async function approveSignup(payload: ApproveSignupPayload) {
  try {
    const response = await PATCH<StandardResponse<unknown>>(ENDPOINTS.SIGNUP_APPROVE, payload);
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/signups/approveSignup', 'Error approving signup');
    toast_error('Error approving signup');
    return Promise.reject(toError(error));
  }
}
